import React from 'react';
import { toast } from 'sonner';
import { dashboardService } from '../services/auth';

// F-M01-1 (US-M01 "Set deal status"): soft pause/resume, no delete. Backend: POST /api/dashboard/deals/{id}/status.
// Ported 2026-11-01 from pages/DashboardDeals.js (commit 1939577), which is unmounted (its route is inside the
// DEPRECATED block in App.js). Mounted merchant surface is pages/Dashboard.js, which renders this component.
// A product can have several deals: the caller renders one button per deal and passes `suffix` to name which deal
// (price / short id) the button controls. The button always acts on exactly the deal object it was given.
export default function DealPauseButton({ deal, onChanged, suffix = '' }) {
  if (!deal || deal.status === 'retired') return null;
  const paused = deal.status === 'paused';
  const toggle = async () => {
    const next = paused ? 'active' : 'paused';
    try {
      await dashboardService.setDealStatus(deal._id, next);
      toast.success(next === 'paused' ? 'Deal paused' : 'Deal resumed');
      if (onChanged) onChanged();
    } catch (error) {
      console.error('Failed to change deal status:', error);
      toast.error('Failed to change deal status');
    }
  };
  return (
    <button
      onClick={toggle}
      className="ml-2 px-3 py-1.5 rounded-lg text-sm font-medium bg-[#FFB020]/10 text-[#FFB020] hover:bg-[#FFB020]/20 transition-colors border border-[#FFB020]/30"
      data-testid="toggle-status-button"
      data-deal-id={deal._id}
    >
      {paused ? 'Resume' : 'Pause'}{suffix}
    </button>
  );
}
